<template>
  <div class="pricing-page">
    <header class="pricing-nav">
      <div class="pricing-nav-inner">
        <router-link to="/login" class="pricing-brand">Media<span>Crawler</span></router-link>
        <router-link to="/login" class="nav-login">登录账号 <i class="el-icon-right"></i></router-link>
      </div>
    </header>

    <section class="pricing-hero">
      <div class="hero-orb hero-orb-left"></div>
      <div class="hero-orb hero-orb-right"></div>
      <div class="hero-content">
        <div class="eyebrow"><i class="el-icon-price-tag"></i> 价格方案</div>
        <h1>灵活定价，<span>随业务成长</span></h1>
        <p>选择适合你阶段的套餐，覆盖多平台数据采集、评论分析与团队协作。</p>
        <div class="billing-toggle" role="tablist" aria-label="计费周期">
          <button :class="{ active: billingCycle === 'monthly' }" @click="billingCycle = 'monthly'">按月</button>
          <button :class="{ active: billingCycle === 'yearly' }" @click="billingCycle = 'yearly'">
            按年 <b>省 20%</b>
          </button>
        </div>
      </div>
    </section>

    <main class="pricing-main">
      <div class="pricing-grid">
        <article
          v-for="plan in plans"
          :key="plan.name"
          class="price-card"
          :class="{ popular: plan.popular }"
        >
          <div class="popular-label" v-if="plan.popular">最受欢迎</div>
          <div class="plan-mark" :class="plan.markClass"><i :class="plan.icon"></i></div>
          <h2>{{ plan.name }}</h2>
          <p class="plan-description">{{ plan.description }}</p>
          <div class="plan-price">
            <span class="currency">¥</span>{{ displayedPrice(plan) }}<small>/月</small>
          </div>
          <p class="billing-note">{{ billingNote(plan) }}</p>
          <button class="plan-button" :class="{ primary: plan.popular }" @click="goToLogin(plan)">
            {{ plan.action }} <i class="el-icon-right"></i>
          </button>
          <div class="feature-divider"></div>
          <ul class="feature-list">
            <li v-for="feature in plan.features" :key="feature.text" :class="{ muted: feature.muted }">
              <i :class="feature.muted ? 'el-icon-close' : 'el-icon-circle-check'"></i>
              <span>{{ feature.text }}</span>
            </li>
          </ul>
        </article>
      </div>

      <section class="custom-plan">
        <div>
          <div class="custom-kicker">ENTERPRISE</div>
          <h2>需要更定制化的方案？</h2>
          <p>大型团队、多品牌管理、私有化部署，我们为你量身打造。</p>
        </div>
        <button class="custom-button" @click="goToLogin({ name: '企业定制' })">
          联系定制 <i class="el-icon-right"></i>
        </button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'PricingPage',
  data() {
    return {
      billingCycle: 'monthly',
      plans: [
        {
          name: '基础版',
          description: '适合个人用户 / 起步阶段',
          monthly: 49,
          yearly: 39,
          action: '选择基础版',
          icon: 'el-icon-sunny',
          markClass: 'mark-blue',
          features: [
            { text: '每日 10 次数据采集' },
            { text: '基础评论分析' },
            { text: '支持 2 个数据平台' },
            { text: '基础数据报表' },
            { text: '团队协作功能', muted: true }
          ]
        },
        {
          name: '专业版',
          description: '成长型团队 / 高频分析',
          monthly: 99,
          yearly: 79,
          action: '开始使用',
          icon: 'el-icon-s-data',
          markClass: 'mark-purple',
          popular: true,
          features: [
            { text: '每日 50 次数据采集' },
            { text: '完整评论分析与趋势' },
            { text: '支持全部数据平台' },
            { text: '历史数据看板' },
            { text: '3 个团队席位' },
            { text: '优先任务队列' }
          ]
        },
        {
          name: '企业版',
          description: '规模化运营 / 多品牌管理',
          monthly: 249,
          yearly: 199,
          action: '联系销售',
          icon: 'el-icon-office-building',
          markClass: 'mark-amber',
          features: [
            { text: '不限次数数据采集' },
            { text: '自定义分析指标' },
            { text: '全平台与 API 对接' },
            { text: '10+ 个团队席位' },
            { text: '专属客户成功经理' },
            { text: '私有化部署支持' }
          ]
        }
      ]
    }
  },
  methods: {
    displayedPrice(plan) {
      return this.billingCycle === 'yearly' ? plan.yearly : plan.monthly
    },
    billingNote(plan) {
      return this.billingCycle === 'yearly'
        ? `按年订阅 ¥${plan.yearly}/月`
        : `按月订阅，随时可取消`
    },
    goToLogin(plan) {
      this.$router.push({ path: '/login', query: { plan: plan.name } })
    }
  }
}
</script>

<style scoped>
.pricing-page {
  min-height: 100vh;
  color: #172033;
  background: #f8fafc;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.pricing-nav {
  height: 70px;
  background: rgba(255, 255, 255, .92);
  border-bottom: 1px solid #e5e7eb;
}

.pricing-nav-inner {
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pricing-brand {
  color: #5b21b6;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -.04em;
  text-decoration: none;
}

.pricing-brand span { color: #172033; }

.nav-login {
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.nav-login:hover { color: #5b21b6; }

.pricing-hero {
  position: relative;
  overflow: hidden;
  padding: 76px 24px 70px;
  background: linear-gradient(135deg, #eef2ff 0%, #fafaff 58%, #f3e8ff 100%);
  text-align: center;
}

.hero-content { position: relative; z-index: 1; max-width: 700px; margin: 0 auto; }

.hero-orb { position: absolute; width: 360px; height: 360px; border-radius: 50%; opacity: .6; }
.hero-orb-left { left: -170px; bottom: -240px; background: rgba(124, 58, 237, .12); }
.hero-orb-right { right: -150px; top: -180px; background: rgba(99, 102, 241, .12); }

.eyebrow {
  display: inline-flex;
  gap: 7px;
  align-items: center;
  margin-bottom: 16px;
  color: #5b21b6;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .12em;
}

.pricing-hero h1 { margin: 0 0 18px; font-size: clamp(34px, 5vw, 52px); line-height: 1.12; letter-spacing: -.05em; }
.pricing-hero h1 span { color: #7c3aed; }
.pricing-hero p { margin: 0; color: #64748b; font-size: 16px; line-height: 1.8; }

.billing-toggle {
  display: inline-flex;
  gap: 4px;
  margin-top: 30px;
  padding: 4px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(79, 70, 229, .08);
}

.billing-toggle button {
  border: 0;
  border-radius: 999px;
  padding: 8px 18px;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}

.billing-toggle button.active { color: #fff; background: #5b21b6; }
.billing-toggle b { margin-left: 4px; color: #059669; font-size: 11px; }
.billing-toggle button.active b { color: #d1fae5; }

.pricing-main { max-width: 1180px; margin: 0 auto; padding: 72px 24px 90px; }
.pricing-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; align-items: stretch; }

.price-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 530px;
  padding: 30px 28px 28px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 8px 30px rgba(15, 23, 42, .035);
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.price-card:hover { transform: translateY(-5px); border-color: #8b5cf6; box-shadow: 0 18px 44px rgba(91, 33, 182, .12); }
.price-card.popular { border: 2px solid #7c3aed; box-shadow: 0 14px 42px rgba(91, 33, 182, .13); }
.popular-label { position: absolute; top: -13px; left: 50%; padding: 5px 18px; color: #fff; background: #7c3aed; border-radius: 999px; transform: translateX(-50%); font-size: 11px; font-weight: 800; white-space: nowrap; }

.plan-mark { display: grid; width: 42px; height: 42px; margin-bottom: 20px; place-items: center; border-radius: 12px; font-size: 19px; }
.mark-blue { color: #2563eb; background: #eff6ff; }
.mark-purple { color: #7c3aed; background: #f5f3ff; }
.mark-amber { color: #d97706; background: #fffbeb; }
.price-card h2 { margin: 0 0 7px; color: #172033; font-size: 21px; letter-spacing: -.03em; }
.plan-description { min-height: 24px; margin: 0 0 22px; color: #64748b; font-size: 13px; }
.plan-price { color: #172033; font-size: 43px; font-weight: 800; letter-spacing: -.06em; line-height: 1; }
.currency { margin-right: 3px; color: #64748b; font-size: 20px; vertical-align: 12px; }
.plan-price small { margin-left: 5px; color: #64748b; font-size: 13px; font-weight: 500; letter-spacing: 0; }
.billing-note { margin: 10px 0 6px; color: #94a3b8; font-size: 12px; }

.plan-button, .custom-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin: 17px 0 23px;
  padding: 12px 16px;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  transition: all .2s ease;
}

.plan-button:hover { color: #5b21b6; background: #f5f3ff; border-color: #8b5cf6; }
.plan-button.primary { color: #fff; background: #7c3aed; border-color: #7c3aed; }
.plan-button.primary:hover { background: #6d28d9; border-color: #6d28d9; }
.feature-divider { border-top: 1px solid #e2e8f0; }
.feature-list { flex: 1; margin: 20px 0 0; padding: 0; list-style: none; }
.feature-list li { display: flex; gap: 9px; align-items: flex-start; margin-bottom: 13px; color: #475569; font-size: 13px; line-height: 1.45; }
.feature-list li i { flex: 0 0 auto; margin-top: 2px; color: #10b981; }
.feature-list li.muted { color: #a8b2c1; }
.feature-list li.muted i { color: #cbd5e1; }

.custom-plan { display: flex; align-items: center; justify-content: space-between; gap: 28px; margin-top: 38px; padding: 30px 36px; background: #fff; border: 1px solid #e2e8f0; border-radius: 18px; }
.custom-kicker { margin-bottom: 7px; color: #7c3aed; font-size: 11px; font-weight: 800; letter-spacing: .14em; }
.custom-plan h2 { margin: 0 0 7px; font-size: 21px; letter-spacing: -.03em; }
.custom-plan p { margin: 0; color: #64748b; font-size: 13px; }
.custom-button { width: auto; min-width: 140px; margin: 0; padding: 12px 21px; color: #5b21b6; background: #f5f3ff; border-color: #ddd6fe; }
.custom-button:hover { color: #fff; background: #7c3aed; border-color: #7c3aed; }

@media (max-width: 820px) {
  .pricing-grid { grid-template-columns: 1fr; max-width: 470px; margin: 0 auto; }
  .price-card.popular { order: -1; }
  .custom-plan { align-items: flex-start; flex-direction: column; }
  .custom-button { width: 100%; }
}

@media (max-width: 480px) {
  .pricing-nav-inner { padding: 0 18px; }
  .pricing-hero { padding: 58px 18px 55px; }
  .pricing-main { padding: 54px 18px 70px; }
  .price-card { padding: 26px 22px; }
  .custom-plan { padding: 25px 22px; }
}
</style>
